/* eslint-disable no-undef */
import { styled } from '@mui/material';

export const Styles = {
  Button: styled('button')<{ selected: boolean }>(({ selected, theme }) => ({
    width: '170px',
    height: '35px',
    borderRadius: '5px',
    backgroundColor: selected ? '#0B327A' : '#2C62C7',
    color: 'white',
    fontSize: '20px',
    fontWeight: 400,
    margin: '0px 15px',
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.3s ease',

    [theme.breakpoints.down('md')]: {
      width: '140px',
      height: '40px',
      fontSize: '18px',
      margin: '0px 8px'
    },

    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: '300px',
      height: '45px',
      fontSize: '16px',
      margin: '5px 0',
      borderRadius: '8px'
    }
  })),

  Container: styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '5px',
    padding: '20px 10px',
    flexWrap: 'wrap',
    marginLeft: '-20px',

    [theme.breakpoints.down('md')]: {
      flexDirection: 'row',
      gap: '10px',
      padding: '15px 5px',
      marginLeft: '0'
    },

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      width: '100%',
      padding: '10px 15px',
      gap: '8px',
      '& button': {
        width: '100%'
      }
    }
  }))
};
